import { captureException } from '@sentry/react';
import LoadingOverlay from 'app/shared-components/util/LoadingOverlay';
import { useAppDispatch } from 'app/store';
import { signOut } from 'app/store/authSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(signOut())
      .unwrap()
      .then(() => {
        // Use replace to prevent /logout from staying in history.
        // Without replace, RequireAuth's "from" state retains /logout/,
        // causing the next sign-in to redirect back to /logout/ immediately.
        navigate('/login', { replace: true });
      })
      .catch((error) => {
        captureException(error);
        navigate('/', { replace: true });
      });
  }, [dispatch, navigate]);

  return <LoadingOverlay isLoading={true} blockInteraction={true} />;
}

export default Logout;
